import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Tabs from '../../../components/tabs';
import TabPanel from "../../../components/tabs/tabpanel";
import { setLoading } from "../../../reducer/auth/auth";
import { list } from "./data";
import Professional from './professional';
import Coaching from './coaching';
import GroupSessions from './groupsessions';
import DemonstrationsSessionsPricing from './demonstrationssessions';
import ExtraServices from './extraservices';
import './style.css';

import {
    stepOneData,
    stepThreeData,
    stepTwoData,
    stepOneDataBackup,
    stepFourData,
} from "../../profile/data";
import {
    getProfileBasicInfo,
    getProfileLeagalAndPrivacy,
    getProfilePreferences,
    getProfileTechnology,
} from "../../../services/admin";
import PayItForward from './payitforward';
import { useTranslation } from "react-i18next";
export default function Princing() {
    const { t } = useTranslation("mediumPricing");
    const dispatch = useDispatch();
    const { id } = useSelector((state) => state.user.user);
    const {sessionPreferences} = useSelector((state) =>  state.user.user);
    const [transactionsList, setTransactionsList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [profileSection, setProfileSection] = useState(null);
    const [profileLoaded, setProfileLoaded] = useState(false);
    const [removeTab, setRemoveTab] = useState(false);

    useEffect(() => {
        if (profileSection === null) getProfile(id);
        console.log("sessionPreferences", sessionPreferences);
    }, []);
   
const filteredList = Array.isArray(sessionPreferences) &&
  !sessionPreferences.includes("Paying Clients")
  ? list.filter((_, index) => index !== 0)
  : list;
    useEffect(() => {
     
    }, [stepOneData]);
    
    const getProfile = (id) => {
        dispatch(setLoading(true))
        getProfileBasicInfo(id)
            .then((data) => {
                dispatch(setLoading(false))
                if (data.data.status) {
                    const {
                        country,
                        first_name,
                        last_name,
                        info,
                        languages,
                        mediumship_level_medium, //which users select
                        mediumship_level, //aprroved
                        phone,
                        specialities,
                        website,
                        whatsapp,
                        timezone,
                        when_do_i_pay,
                        session_length,
                        session_currency,
                        profile_image,
                        encoded_image,
                        zoom,
                        google,
                        medium_professional_category,
                        recommendation,
                        encrypted_id,
                        personal_booking_link,
                        is_square_integrated,
                        is_stripe_integrated,
                        is_paypal_integrated,
                        test_mode,
                        extra_services,
                        extra_services_data,
                        extra_services_list,
                        coaching_pricing,
                        hosting_circle_pricing,
                        hosting_qa_pricing,
                        comments,
                        payitforward_pricing,
                        payitforward_coaching_pricing,
                        coaching_info,
                         group_coaching,
                        coached_practice_circles,
                        speaker_events,
                        demo_practice,
                        demo_professional
                    } = data.data.data;
                   
                    stepOneData.test_mode = test_mode
                    stepOneData.is_square_integrated = is_square_integrated !== undefined && is_square_integrated ? true : false
                    stepOneData.is_stripe_integrated = is_stripe_integrated !== undefined && is_stripe_integrated ? true : false
                    stepOneData.is_paypal_integrated = is_paypal_integrated !== undefined && is_paypal_integrated ? true : false
                    stepOneData.personal_booking_link = personal_booking_link;
                    stepOneData.encrypted_id = encrypted_id;
                    stepOneData.zoom = zoom !== null ? zoom : "";
                    stepOneData.google = google !== null ? google : "";
                    stepOneData.profile_image =
                        profile_image !== "" ? profile_image : null;
                    stepOneData.encoded_image = encoded_image;
                    stepOneData.firstName = first_name;
                    stepOneData.lastName = last_name;
                    stepOneData.website = website;
                    stepOneData.country = country;
                    stepOneData.biographicalInfo = info;
                    stepOneData.phone = phone;
                    stepOneData.mediumshipLevel = parseInt(mediumship_level_medium);
                    stepOneData.mediumship_level = parseInt(mediumship_level);

                    stepOneData.recommendation =
                        recommendation !== null ? recommendation : "";

                    stepOneData.medium_professional_category = medium_professional_category;
                    stepOneData.whatsapp = whatsapp;
                    stepOneData.when_do_i_pay =
                        when_do_i_pay !== undefined
                            ? when_do_i_pay.map((item) => {
                                return String(item);
                            })
                            : [];
                    stepOneData.session_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[0] !== "" ? Object.values(JSON.parse(session_currency))[0] : "USD"
                            : "USD";
                    stepOneData.session_length_30_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[0]
                            : "";
                    stepOneData.session_length_45_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[1]
                            : "";
                    stepOneData.session_length_60_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[2]
                            : "";
                    stepOneData.session_length_45_2_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[3]
                            : "";
                    stepOneData.session_length_60_2_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[4]
                            : "";

                    stepOneData.session_length_30 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[0]
                            : "";

                    stepOneData.session_length_45 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[1]
                            : "";
                    stepOneData.session_length_60 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[2]
                            : "";
                    stepOneData.session_length_45_2 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[3]
                            : "";
                    stepOneData.session_length_60_2 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[4]
                            : "";
                    stepOneData.extra_services = extra_services;
                    stepOneData.extra_services_data = extra_services_data;
                     stepOneData.extra_services_list = extra_services_list !== null ? 
                                           extra_services_list.map((item) => {
                                             return {
                                               id: item.id,
                                               amount: item.amount,
                                               name: item.sub_session_name,
                                             };
                                           }) 
                                         : "";
                    stepOneData.timezone = { ...timezone, value: timezone.id, label: timezone.front_name };
                    stepOneData.coaching_pricing_30 = coaching_pricing !== null && coaching_pricing !== undefined ? Object.values(JSON.parse(coaching_pricing))[0] : '';
                    stepOneData.coaching_pricing_60 = coaching_pricing !== null && coaching_pricing !== undefined ? Object.values(JSON.parse(coaching_pricing))[1] : '';
                    stepOneData.hosting_circle_pricing_30 = hosting_circle_pricing !== null && hosting_circle_pricing !== undefined ? Object.values(JSON.parse(hosting_circle_pricing))[0] : '';
                    stepOneData.hosting_qa_pricing_30 = hosting_qa_pricing !== null && hosting_qa_pricing !== undefined ? Object.values(JSON.parse(hosting_qa_pricing))[0] : '';
                    stepOneData.comments = comments
                    stepOneData.coaching_info = coaching_info

                    stepOneData.payitforward_pricing_30= payitforward_pricing !== null && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[0]
                    : "";
                    stepOneData.payitforward_pricing_45= payitforward_pricing !== null && payitforward_pricing !== undefined  ? Object.values(JSON.parse(payitforward_pricing))[1]
                    : "";
                    stepOneData.payitforward_pricing_60= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[2]
                    : "";
                    stepOneData.payitforward_pricing_45_2= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[3]
                    : "";
                    stepOneData.payitforward_pricing_60_2= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[4]
                    : "";
                    stepOneData.payitforward_coaching_pricing= payitforward_coaching_pricing !== null  && payitforward_coaching_pricing !== undefined ? payitforward_coaching_pricing
                    : "";

                    stepOneData.group_coaching = group_coaching !== null && group_coaching !== undefined ? group_coaching : 0;
                    stepOneData.coached_practice_circles = coached_practice_circles !== null && coached_practice_circles !== undefined ? coached_practice_circles : 0;
                    stepOneData.speaker_events = speaker_events !== null && speaker_events !== undefined ? speaker_events : 0;
                    stepOneData.demo_practice = demo_practice !== null && demo_practice !== undefined ? demo_practice : 0;
                    stepOneData.demo_professional = demo_professional !== null && demo_professional !== undefined ? demo_professional : 0;
                    
                    
                    dispatch(setLoading(false))
                    setProfileSection(data.data.data);
                    setProfileLoaded(true);
                }
            })
            .catch((err) => {
                dispatch(setLoading(false))
                console.log(err)
            });
    }
    const handleProfileUpdate = () => {
        // Your logic here, e.g., updating state, calling an API, etc.
        getProfile(id)
      };
      const prefs = Array.isArray(sessionPreferences) ? sessionPreferences : [];
      const [extraServices, setExtraServices] = useState(true);

  const hasPayingClients = prefs.includes("Paying Clients");
  const hasCoaching = prefs.includes("Coaching");
  const hasExtraServices = prefs.includes("Extra Services");
  const hasGroupSession = prefs.includes("Group Session");
  const hasPracticeCircle = prefs.includes("Practice Circles");
  // "Practice Demos" is the pre-rename spelling of "Host Practice Demonstration"; both are
  // accepted so pricing stays visible whichever label the medium's row still carries.
  const hasPracticeDemos =
    prefs.includes("Host Practice Demonstration") || prefs.includes("Practice Demos");
  const hasProfessionalSessions = prefs.includes("Professional Demonstrations");

  /* 2️⃣ Build tabs list dynamically (PUT HERE) */
  const filteredTabs = [];

  if (hasPayingClients) {
    filteredTabs.push({ key: "professional", name: t("tabs.professional") });
  }

  if (hasCoaching) {
    filteredTabs.push({ key: "coaching", name: t("tabs.coaching") });
  }

  if ((hasCoaching || hasPayingClients) && removeTab) {
    filteredTabs.push({
      key: "payitforward",
      name: t("tabs.payItForward"),
    });
  }

  if (hasExtraServices) {
    filteredTabs.push({ key: "extraservices", name: t("tabs.extraServices") });
  }

  if (hasGroupSession || hasPracticeCircle) {
    filteredTabs.push({
      key: "groupsessions",
      name: t("tabs.groupSessions"),
    });
  }

  if (hasPracticeDemos || hasProfessionalSessions) {
    filteredTabs.push({
      key: "demonstrations",
      name: t("tabs.demonstrations"),
    });
  }

  /* 3️⃣ Set first available tab automatically */
  useEffect(() => {
    if (filteredTabs.length > 0) {
      setActiveTab(0);
    }
  }, [sessionPreferences]);


    return (
        <div className="all-medium-page pricing-page">
            <Tabs  active={activeTab}
  list={filteredTabs}
  setActiveTab={setActiveTab} />
            <ul className="tabs-content">
  {filteredTabs.map((tab, index) => {
    switch (tab.key) {
      case "professional":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            {profileLoaded && (
              <Professional
                stepOneData={stepOneData}
                id={id}
                onProfileUpdate={handleProfileUpdate}
              />
            )}
          </TabPanel>
        );

      case "coaching":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            <Coaching
              stepOneData={stepOneData}
              id={id}
              onProfileUpdate={handleProfileUpdate}
            />
          </TabPanel>
        );

      case "payitforward":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            <PayItForward
              stepOneData={stepOneData}
              id={id}
              onProfileUpdate={handleProfileUpdate}
            />
          </TabPanel>
        );

      case "extraservices":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            <ExtraServices
              stepOneData={stepOneData}
              id={id}
              onProfileUpdate={handleProfileUpdate}
            />
          </TabPanel>
        );

      case "groupsessions":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            <GroupSessions
              stepOneData={stepOneData}
              id={id}
              onProfileUpdate={handleProfileUpdate}
            />
          </TabPanel>
        );

      case "demonstrations":
        return (
          <TabPanel key={tab.key} id={index} activeTab={activeTab}>
            <DemonstrationsSessionsPricing
              stepOneData={stepOneData}
              id={id}
              onProfileUpdate={handleProfileUpdate}
            />
          </TabPanel>
        );

      default:
        return null;
    }
  })}
</ul>

        </div>
    )
}
